'use client';

import Pagination from '@mui/material/Pagination';
import { useSearchParams } from 'next/navigation';
import { FC } from 'react';
import { useRouter } from 'modules/i18n/navigation';
import styles from './styles.module.css';

export const ManualPagination: FC<{ count: number; page: number }> = ({
  count,
  page,
}) => {
  const router = useRouter();
  const searchParams = useSearchParams();

  return (
    <div className={styles.paginationContainer}>
      {count > 1 && (
        <Pagination
          className={styles.pagination}
          count={count}
          page={page}
          onChange={(_, page) => {
            const newParams = new URLSearchParams(searchParams.toString());
            newParams.set('page', page.toString());
            router.push(`?${newParams.toString()}`);
          }}
        />
      )}
    </div>
  );
};
